import _ from 'underscore';
import moment from 'moment';
import i18n from 'i18next';
import d from '../../../build/dependencies/cloudui-dictionary';
import greek from 'libs/country-list/el/country.json';
import english from 'libs/country-list/en_US/country.json';
import i18nLangDet from "i18next-browser-languagedetector";

import $i18n from "jquery-i18next";
import * as $ from "jquery";

$i18n.init(i18n, $, {
    tName: 't', // --> appends $.t = i18next.t
    i18nName: 'i18n', // --> appends $.i18n = i18next
    handleName: 'i18n', // --> appends $(selector).localize(opts);
    selectorAttr: 'data-i18n', // selector for translating elements
    targetAttr: 'i18n-target', // data-() attribute to grab target element to translate (if diffrent then itself)
    optionsAttr: 'i18n-options', // data-() attribute that contains options, will load/set if useOptionsAttr = true
    useOptionsAttr: false, // see optionsAttr
    parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
});

i18n.use(i18nLangDet)
    .init({
        fallbackLng: 'el',
        initImmediate: false,
        resources: d,
        whitelist: ['en', 'el'],
        detection: {
            order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag']
        }
    });

moment.locale(i18n.language);

const translations = {
    en: english,
    el: greek
};

i18n.labels7ConsecutiveDays = function (m) {
    const ld = m.localeData();
    const weekdays = ld._weekdaysMin;
    const startDay = m.get("day");
    return _.map(_.range(startDay + 1, startDay + 8),
        function (i) {
            return weekdays[i % 7];
        });
};

i18n.labels = function (m, window, unit, sz) {
    if (window === "all") {
        const startDate = m.clone().startOf(unit);
        const now = moment().startOf(unit);
        const labels = [];
        while (startDate <= now) {
            let label;
            switch (unit) {
                case "month":
                    label = startDate.format("MM/YYYY");
                    break;
                case "year":
                    label = startDate.format("YYYY");
                    break;
                default:
                    label = startDate.format("L");
                    break;
            }
            labels.push(label);
            startDate.add(1, unit);
        }
        return labels;
    } else {
        let ld;
        switch (unit) {
            case "hour":
                return _.range(0, 24);
            case "day":
                if (window === "week") {
                    ld = m.localeData();
                    const weekdays = ld._weekdaysMin;
                    return _.map(_.range(ld.firstDayOfWeek(), ld.firstDayOfWeek() + 7), i => weekdays[i % 7]);
                } else {
                    return _.range(1, m.daysInMonth() + 1);
                }
            case "week":
                return _.range(1, sz + 1);
            case "month":
                ld = m.localeData();
                return ld._monthsShort;
            default:
                return null;
        }
    }
};

i18n.truncLang = function () {
    const i = i18n.language.indexOf("-");
    return i === -1 ? i18n.language : i18n.language.substring(0, i);
};

i18n.defaultDateFormat = function () {
    return moment().localeData()
        .longDateFormat("L")
        .replace(/MM/, "M")
        .replace(/DD/, "D");
};

i18n.defaultDateFormatJava = function () {
    const ld = moment().localeData();
    return ld.longDateFormat("L")
        .replace(/Y/g, "y")
        .replace(/DD/g, "d")
        .replace(/MM/g, "M");
};

const suffixes = {
    "el": ["η"],
    "en": ["th", "st", "nd", "rd"]
};

i18n.ordinalSuffix = function (count) {
    if (count < 0)
        count = 0;
    const lng = i18n.truncLang();
    count = parseInt(count);
    if (suffixes[lng]) {
        const s = suffixes[lng];

        const lastTwoDigits = count > 99 ? count - ((parseInt(count / 100)) * 100) : count;
        const lastOneDigit = parseInt(lastTwoDigits) % 10;
        if (lastTwoDigits === 11 || lastTwoDigits === 12 || lastTwoDigits === 13) {
            return s[0];
        } else {
            return s[lastOneDigit > s.length - 1 ? 0 : lastOneDigit];
        }
    } else {
        return "";
    }
};

i18n.findCountryFromCode = function (code) {
    const array = translations[i18n.language];
    return array[code];
};

i18n.getCountries = function () {
    return translations[i18n.language];
};

i18n.getDir = function () {
    return i18n.language === "fa" ? "rtl" : "ltr";
};

console.log(`Loaded dictionary. Translation of key: ${i18n.t("languagecode")}`);

export default i18n;
